import { render, staticRenderFns } from "./ClientContentList.vue?vue&type=template&id=65e87a12&scoped=true&"
import script from "./ClientContentList.vue?vue&type=script&lang=js&"
export * from "./ClientContentList.vue?vue&type=script&lang=js&"
import style0 from "./ClientContentList.vue?vue&type=style&index=0&id=65e87a12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e87a12",
  null
  
)

export default component.exports